import { DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY, type Language } from './Language';

/**
 * The language in force, read where React is not — the API client sends it as `accept-language`, so the
 * API's error messages arrive in the language the screen is in.
 */
export const readStoredLanguage = (): Language => {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);

    return stored === 'en' || stored === 'sk' ? stored : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

export const writeStoredLanguage = (language: Language): void => {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // The choice simply does not survive a reload.
  }
};
